import { useDispatch, useSelector } from "react-redux";
import { selectToken } from "../../app/slices/AuthenticationSlice";
import { setIsLoading } from "../../app/slices/GlobalSlice";
import {
  LanguageData,
  addAutoTranslatedLanguage,
  addMissingAutoTranslatedKeys,
  selectTrainingLocalizationState,
} from "../../app/slices/TrainingLocalizationSlice";
import {
  selectReferenceLanguage,
} from "../../app/slices/TrainingSlice";
import { TranslationService } from "../../services/TranslationService";
import { v4 as uuidv4 } from "uuid";
import {
  beginHistoryTransaction,
  cancelHistoryTransaction,
  commitHistoryTransaction,
} from "../../app/slices/HistorySlice";

export default function useAutotranslation() {
  const locState = useSelector(selectTrainingLocalizationState);
  const token = useSelector(selectToken);
  const referenceLanguage = useSelector(selectReferenceLanguage);
  const dispatch = useDispatch();

  const translateAll = async (lang: LanguageData) => {
    var from = referenceLanguage;
    var to = lang.shortcode;
    var texts: string[] = [];

    for (var key in locState.localizedEntries) {
      texts.push(locState.localizedEntries[key][from].value);
    }

    var translatedTexts = await TranslationService.TranslateTexts(
      token,
      texts,
      from,
      to
    );

    dispatch(
      addAutoTranslatedLanguage({
        lang: lang,
        translatedValues: translatedTexts,
      })
    );

  };

  const translateMissing = async (lang: LanguageData) => {
    var from = referenceLanguage;
    var to = lang.shortcode;
    var texts: string[] = [];

    for (var key in locState.localizedEntries) {
      texts.push(locState.localizedEntries[key][from].value);
    }

    //dispatch(setIsLoading(true));
    var translatedTexts = await TranslationService.TranslateTexts(
      token,
      texts,
      from,
      to
    );

    dispatch(
      addMissingAutoTranslatedKeys({
        lang: lang,
        translatedValues: translatedTexts,
      })
    );

    // dispatch(setIsLoading(false));
  };

  const translateMultipleMissing = async (langData: LanguageData[]) => {
    const transaction = { id: `translate-missing-${uuidv4()}` };
    dispatch(setIsLoading(true));
    dispatch(beginHistoryTransaction(transaction));
    try {
      for (var lang of langData) {
        if (lang.shortcode === referenceLanguage) continue;
        await translateMissing(lang);
      }
      dispatch(commitHistoryTransaction(transaction));
    } catch (error) {
      dispatch(cancelHistoryTransaction(transaction));
      throw error;
    } finally {
      dispatch(setIsLoading(false));
    }
  };

  const translateMultipleAll = async (langData: LanguageData[]) => {
    const transaction = { id: `translate-all-${uuidv4()}` };
    dispatch(setIsLoading(true));
    dispatch(beginHistoryTransaction(transaction));
    try {
      for (var lang of langData) {
        if (lang.shortcode === referenceLanguage) continue;
        await translateAll(lang);
      }
      dispatch(commitHistoryTransaction(transaction));
    } catch (error) {
      dispatch(cancelHistoryTransaction(transaction));
      throw error;
    } finally {
      dispatch(setIsLoading(false));
    }
  };

  return {
    translateMultipleMissing,
    translateMultipleAll,
  } as const;
}
